import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DropdownComponent } from '../../../../framework/inputs/dropdown/dropdown.component';
import { RegistrationForm, SERVICE_PROVIDER_TYPES } from '../../auth.constants';
import { FloatingInputComponent } from '../../../../framework/inputs/floating-input/floating-input.component';

@Component({
  selector: 'app-register-service-provider-form',
  imports: [DropdownComponent, ReactiveFormsModule, FloatingInputComponent],
  templateUrl: './register-service-provider-form.component.html',
  styleUrl: './register-service-provider-form.component.scss',
})
export class RegisterServiceProviderFormComponent {
  protected readonly SERVICE_PROVIDER_TYPES = SERVICE_PROVIDER_TYPES;
  @Input({ required: true }) registrationForm: FormGroup<RegistrationForm>;
}
